import { helper } from "src/utils/helper";

class PatolojiNumuneKabulAramaKriterleri {
    baslangicTarih?: string = helper.datetimeToday();
    bitisTarih?: string = helper.datetimeToday();
    barkodNo?: number = null;
    acil?: string = "H";
    durum?: number = 1000;
    organizasyonId?: number = null;
    raporTipTanimId?: number = null;
    kimlikId: number = null;
    sorguDurum?: string = "1"; //Kabule göre "default: 1"
    protokolOnEk?: string = "";
    protokolYil?: number = helper.objectToNumber(helper.datetimeToyear());
    protokolNo?: number = null;
    kurumId?: number = null;
    patolojiNo?: number = null;
    biyopsiNo?: string = "";
    taniId?: string = null;
    gonderilecekBirimId?: number = null;
    rezervBarkodNo?: number = null;
    icKurumBarkodNo?: string = "";
}
export default PatolojiNumuneKabulAramaKriterleri;